import styled from "styled-components";
import { Typography } from "@mui/material";
import { OuterWrapper } from "../wrapper/wrapper";

export const HeroBackground = styled(OuterWrapper)`
  && {
    height: 300px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const HeroText = styled(Typography)`
  && {
    text-align: center;
    position: relative;
    top: 110px;

    font-family: "Noto Serif";
    font-style: normal;
    font-weight: 700;
    font-size: 50px;
    line-height: 68px;
    letter-spacing: 0.05em;
    color: #ffffff;
  }
`;
